import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入样式

Vue.config.productionTip = false

// 将 Message 挂载到 Vue 原型，方便在组件中使用 this.$message
Vue.prototype.$message = ElementUI.Message;

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')